/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dependencyEdgeSchema } from './dependencyEdgeSchema';

export const itemDependencyStateSchema = z.object({
  atRiskPredecessorIds: z
    .array(z.int())
    .describe('Predecessor item ids causing this item to be at risk. Deprecated, use edges.'),
  atRiskSuccessorIds: z
    .array(z.int())
    .describe(
      'Successor item ids this item puts at risk. Empty unless dependency rules V2 are enabled.',
    ),
  blockedByPredecessorIds: z
    .array(z.int())
    .describe('Predecessor item ids causing this item to be blocked. Deprecated, use edges.'),
  blockedSuccessorIds: z
    .array(z.int())
    .describe(
      'Reserved, always empty: a successor can only be at risk, never blocked, so blocked successors are reported in atRiskSuccessorIds.',
    ),
  get edges() {
    return z
      .array(dependencyEdgeSchema)
      .describe('Typed dependency edges covering both predecessor and successor directions');
  },
  status: z
    .enum(['NO_ISSUE', 'AT_RISK', 'BLOCKED', 'CANNOT_EVALUATE'])
    .describe('Dependency state derived from predecessor status'),
});
